import {firestore} from "../firebase";

export default firestore;
